import {Injectable} from '@angular/core';
import {TypeValuePair} from '../models/type-value-pair';

export const STRIPE_CUSTOMER_IDS = 'stripeCustomerIds';

@Injectable({
  providedIn: 'root',
})
export class JsonService {
  public parseSafely(rawJson: string | undefined): any {
    if (rawJson?.length) {
      try {
        return JSON.parse(rawJson) as any;
      } catch (e) {}
    }
    return undefined;
  }

  findDataSet(data: TypeValuePair[], type: string): TypeValuePair {
    if (data?.length) {
      const finding: TypeValuePair | undefined = data.find((entry) => entry.type === type);
      if (finding) {
        return finding;
      }
    }
    return {value: undefined, type};
  }

  /**
   * Finds and parses a dataset in an array of datasets that can be appended to any Commerce object.
   *
   * @param data array of data entries
   * @param type type of the data entry to look for.
   */
  public getJsonDataValue(data: TypeValuePair[], type: string) {
    return this.parseSafely(this.findDataSet(data, type).value);
  }
}
